import * as Types from './mutation-types'
import { API_STATES } from '@/helpers'

const mutations = {
  [Types.USER_EMAILVERIFICATION_BEGIN] (state ) {
    state.userEmailVerificationState = API_STATES.REQUEST_PENDING
    state.userEmailVerificationErr = null
  },
  [Types.USER_EMAILVERIFICATION_SUCCESS] (state,verification) {
    state.userEmailVerification = verification
    state.userEmailVerificationState = API_STATES.REQUEST_SUCCESS
    state.userEmailVerificationErr = null
  },
  [Types.USER_EMAILVERIFICATION_ERROR] (state,err) {
    state.userEmailVerificationState = API_STATES.REQUEST_ERROR
    state.userEmailVerificationErr = err
  },
  [Types.RESEND_EMAILVERIFICATION_BEGIN] (state ) {
    state.resendEmailVerificationState = API_STATES.REQUEST_PENDING
    state.resendEmailVerificationErr = null
  },
  [Types.RESEND_EMAILVERIFICATION_SUCCESS] (state) {
    state.resendEmailVerificationState = API_STATES.REQUEST_SUCCESS
    state.resendEmailVerificationErr = null
  },
  [Types.RESEND_EMAILVERIFICATION_ERROR] (state,err) {
    state.resendEmailVerificationState = API_STATES.REQUEST_ERROR
    state.resendEmailVerificationErr = err
  },
  [Types.ONBOARDING_SIGNUP_BEGIN] (state ) {
    state.onboardingSignupState = API_STATES.REQUEST_PENDING
    state.onboardingSignupErr = null
  },
  [Types.ONBOARDING_SIGNUP_SUCCESS] (state) {
    state.onboardingSignupState = API_STATES.REQUEST_SUCCESS
    state.onboardingSignupErr = null
  },
  [Types.ONBOARDING_SIGNUP_ERROR] (state,err) {
    state.onboardingSignupState = API_STATES.REQUEST_ERROR
    state.onboardingSignupErr = err
  },
  [Types.USER_SIGNUP_BEGIN] (state ) {
    state.userSignupState = API_STATES.REQUEST_PENDING
    state.userSignupErr = null
  },
  [Types.USER_SIGNUP_SUCCESS] (state) {
    state.userSignupState = API_STATES.REQUEST_SUCCESS
    state.userSignupErr = null
  },
  [Types.USER_SIGNUP_ERROR] (state,err) {
    state.userSignupState = API_STATES.REQUEST_ERROR
    state.userSignupErr = err
  },
  [Types.VERIFY_EMAIL_BEGIN] (state ) {
    state.verifyEmailState = API_STATES.REQUEST_PENDING
    state.verifyEmailErr = null
  },
  [Types.VERIFY_EMAIL_SUCCESS] (state) {
    state.verifyEmailState = API_STATES.REQUEST_SUCCESS
    state.verifyEmailErr = null
  },
  [Types.VERIFY_EMAIL_ERROR] (state,err) {
    state.verifyEmailState = API_STATES.REQUEST_ERROR
    state.verifyEmailErr = err
  },
  [Types.IMPORT_USERS_BEGIN] (state ) {
    state.importUserState = API_STATES.REQUEST_PENDING
  },
  [Types.IMPORT_USERS_SUCCESS] (state) {
    state.importUserState = API_STATES.REQUEST_SUCCESS
    state.importUserErr = null
  },
  [Types.IMPORT_USERS_ERROR] (state,err) {
    state.importUserState = API_STATES.REQUEST_ERROR
    state.importUserErr = err
  },
}

export default mutations
